/**
 * 全局指令
 */
import Vue from 'vue';
/**
 * 防止多次点击，重复请求
 */

var preventReClick = Vue.directive('preventReClick', {
  inserted: function inserted(el, binding) {
    el.addEventListener('click', function () {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(function () {
          el.disabled = false;
        }, binding.value || 1000);
      }
    });
  }
});
/**
 * 按钮点击校验必填项未填如果是输入框则聚焦
 */

var errorTipFocus = Vue.directive('errorTipFocus', {
  inserted: function inserted(el, binding) {
    el.addEventListener('click', function () {
      var error_div = document.body.querySelector('.ivu-form-item-error-tip');
      var that = new Vue();
      that.$nextTick(function () {
        if (error_div) {
          document.body.querySelector('.ivu-form-item-error-tip').scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          var adjacentNode = error_div.parentNode.firstChild;
          var classList = adjacentNode.getAttribute('class'); // 'ivu-input-type-'来校验input type类型 'ivu-input-number-default'校验InputNumer数字输入框

          if (classList.includes('ivu-input-type-') || classList.includes('ivu-input-number-default')) {
            // 文本域聚焦
            adjacentNode.getElementsByTagName('textarea')[0] && adjacentNode.getElementsByTagName('textarea')[0].select(); // 普通输入框聚焦

            adjacentNode.getElementsByTagName('input')[0] && adjacentNode.getElementsByTagName('input')[0].select();
          }
        }
      });
    });
  }
});
/**
 * 控制按钮权限
 */

var permission = Vue.directive('permission', {
  inserted: function inserted(el, binding) {
    var array = JSON.parse(sessionStorage.getItem('auth'));

    if (array.length > 0) {
      array.find(function (item) {
        return item === binding.value;
      }) || el.parentNode.removeChild(el);
    }
  }
});
/**
 * 结束时间默认为当天的23：59：59
 * 指令用法： v-endTimeDefault = 'time' 或者  v-endTimeDefault = 'query.time' 或者 v-endTimeDefault = 'query.data.time'
 *  expression： 里面传 v-model
 */

var endTimeDefault = Vue.directive('endTimeDefault', {
  update: function update(el, binding, vnode) {
    var newValue = binding.value;

    if (newValue !== '') {
      var nowDate = new Date(newValue);
      var dateTime = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate() + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes() + ':' + nowDate.getSeconds(); // 截取日期的时间

      var time = dateTime.substring(dateTime.indexOf(' ') + 1); // 判断时间是否是 00:00:00

      var flag = false;

      if (time === '00:00:00' || time === '0:0:0') {
        flag = true;
      }

      if (flag) {
        var newTime = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate() + ' ' + '23:59:59'; // 传参

        var timeKey = binding.expression;
        var timeObj = [];

        if (timeKey.includes('.')) {
          timeObj = timeKey.split('.');
        } else {
          timeObj.push(timeKey);
        }

        switch (timeObj.length) {
          case 1:
            var key = timeObj[0];
            vnode.context[key] = newTime;
            break;

          case 2:
            var keyA = timeObj[0];
            var keyB = timeObj[1];
            vnode.context[keyA][keyB] = newTime;
            break;

          case 3:
            var keyC = timeObj[0];
            var keyD = timeObj[1];
            var keyE = timeObj[2];
            vnode.context[keyC][keyD][keyE] = newTime;
            break;

          default:
            break;
        }
      }
    }
  }
});
/**
 * 结束时间默认为当天的23：59：59
 * 指令用法： v-limitdecimal = 'data' data 是双向数据绑定的值
 * 【暂时只限制两位小数】 不支持iview的input框
 */

var setPathValue = function setPathValue(Obj, arr, val) {
  // obj 要改变的值 str 类 a.b.c 的字符串
  if (arr.length > 1) {
    var newArr = [].concat(arr);
    newArr.shift();
    setPathValue(Obj[arr[0]], newArr, val);
  } else if (arr.length === 1) {
    Obj[arr[0]] = val;
  } else {
    return false;
  }
};

var setdecimal = function setdecimal(val) {
  val = val.replace(/[^\d.]/g, ''); // 清除"数字"和"."以外的字符

  val = val.replace(/^\./g, ''); // 验证第一个字符是数字而不是

  val = val.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的

  val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数

  return val;
};

var limitdecimal = Vue.directive('limitdecimal', {
  bind: function bind(el, bidding, vnode) {
    // 只调用一次，第一次绑定指令到元素时调用，我们可以在此绑定只执行一次的初始化动作
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    setTimeout(function () {
      el.value = currVal;
    }, 0);

    el.onkeyup = function (e) {
      var val = setdecimal(e.target.value);
      setPathValue(context, expression, val);
      el.value = val;
    };

    el.onmouseup = function (e) {
      var val = setdecimal(e.target.value);
      setPathValue(context, expression, val);
      el.value = val;
    };

    el.onblur = function (e) {
      var val = e.target.value;
      el.value = Number(val).toFixed(2);
      setPathValue(context, expression, Number(val).toFixed(2));
    };
  },
  inserted: function inserted(el, bidding) {// 被绑定元素插入父节点时调用（父节点只要存在即可调用，不必存在于 document 中）。
  },
  update: function update(el, bidding, vnode) {
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    el.value = currVal;
  }
});
/**
 * 结束时间默认为当天的23：59：59
 * 指令用法： v-limitdecimal = 'data' data 是双向数据绑定的值
 * 【暂时只限制两位小数】 仅支持iview的input框
 */

var ivlimitdecimal = Vue.directive('ivlimitdecimal', {
  bind: function bind(el, bidding, vnode) {
    // 只调用一次，第一次绑定指令到元素时调用，我们可以在此绑定只执行一次的初始化动作
    var input = el.getElementsByTagName('input')[0];
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    setTimeout(function () {
      input.value = currVal;
    }, 0);

    input.onkeyup = function (e) {
      var val = setdecimal(e.target.value);
      setPathValue(context, expression, val);
      input.value = val;
    };

    input.onmouseup = function (e) {
      var val = setdecimal(e.target.value);
      setPathValue(context, expression, val);
      input.value = val;
    };

    input.onblur = function (e) {
      var val = e.target.value;
      input.value = Number(val).toFixed(2);
      setPathValue(context, expression, Number(val).toFixed(2));
    };
  },
  inserted: function inserted(el, bidding, vnode) {// 被绑定元素插入父节点时调用（父节点只要存在即可调用，不必存在于 document 中）。
  },
  update: function update(el, bidding, vnode) {
    var input = el.getElementsByTagName('input')[0];
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    input.value = currVal;
  }
});
/**
 * 结束时间默认为当天的23：59：59
 * 指令用法： v-ivlimitdeInteger = 'data' data 是双向数据绑定的值
 * 【暂时限制只能输入正整数】 仅支持iview的input框
 */

var setInteger = function setInteger(val) {
  val = val.replace(/[^\d]/g, ''); // 清除"数字"以外的字符

  return val;
};

var ivlimitdeInteger = Vue.directive('ivlimitdeInteger', {
  bind: function bind(el, bidding, vnode) {
    // 只调用一次，第一次绑定指令到元素时调用，我们可以在此绑定只执行一次的初始化动作
    var input = el.getElementsByTagName('input')[0];
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    setTimeout(function () {
      input.value = currVal;
    }, 0);

    input.onkeyup = function (e) {
      var val = setInteger(e.target.value);
      setPathValue(context, expression, val);
      input.value = val;
    };

    input.onmouseup = function (e) {
      var val = setInteger(e.target.value);
      setPathValue(context, expression, val);
      input.value = val;
    };

    input.onblur = function (e) {
      var val = e.target.value;
      input.value = Number(val);
      setPathValue(context, expression, Number(val));
    };
  },
  inserted: function inserted(el, bidding, vnode) {// 被绑定元素插入父节点时调用（父节点只要存在即可调用，不必存在于 document 中）。
  },
  update: function update(el, bidding, vnode) {
    var input = el.getElementsByTagName('input')[0];
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    input.value = currVal;
  }
});
/**
 * 结束时间默认为当天的23：59：59
 * 指令用法： v-limitdeInteger = 'data' data 是双向数据绑定的值
 * 【暂时限制只能输入正整数】 仅支持纯input框
 */

var limitdeInteger = Vue.directive('limitdeInteger', {
  bind: function bind(el, bidding, vnode) {
    // 只调用一次，第一次绑定指令到元素时调用，我们可以在此绑定只执行一次的初始化动作
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    setTimeout(function () {
      el.value = currVal;
    }, 0);

    el.onkeyup = function (e) {
      var val = setInteger(e.target.value);
      setPathValue(context, expression, val);
      el.value = val;
    };

    el.onmouseup = function (e) {
      var val = setInteger(e.target.value);
      setPathValue(context, expression, val);
      el.value = val;
    };

    el.onblur = function (e) {
      var val = e.target.value;
      el.value = Number(val);
      setPathValue(context, expression, Number(val));
    };
  },
  inserted: function inserted(el, bidding, vnode) {// 被绑定元素插入父节点时调用（父节点只要存在即可调用，不必存在于 document 中）。
  },
  update: function update(el, bidding, vnode) {
    var context = vnode.context;
    var expression = bidding.expression.split('.');
    var currVal = expression.reduce(function (pre, next) {
      return pre[next];
    }, context);
    el.value = currVal;
  }
});
export { preventReClick, permission, endTimeDefault, limitdecimal, ivlimitdecimal, ivlimitdeInteger, limitdeInteger, errorTipFocus };